import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import Grid from "@material-ui/core/Grid";
import AceEditor from "react-ace";
import "brace/ext/language_tools";
import "brace/mode/javascript";
import "brace/theme/xcode";
import PropTypes from "prop-types";
import React, {Fragment, memo} from "react";
import CustomCheckbox from "./common/CustomCheckbox";

const MacroEditor = ({label, name, value, useMacro, onCheckBoxChange, onEditorChange, onReset}) => {
    return (
        <Fragment>
            <Grid container spacing={2} alignItems={"center"}>
                <Grid item xs>
                    <CustomCheckbox label={label}
                                    name={name}
                                    onChange={onCheckBoxChange}
                                    checked={useMacro}/>
                </Grid>
                <Grid item>
                    {useMacro ?
                        <Button onClick={() => onReset(name)}
                                variant="contained"
                                color="primary">
                            Reset
                        </Button> : null}
                </Grid>
            </Grid>
            <Collapse in={useMacro}>
                <AceEditor
                    width="inherit"
                    mode="javascript"
                    theme="xcode"
                    onChange={(value) => onEditorChange(name, value)}
                    showPrintMargin={false}
                    value={value}
                    setOptions={{
                        enableBasicAutocompletion: true,
                        enableLiveAutocompletion: true,
                        showLineNumbers: false,
                        tabSize: 2
                    }}/>
            </Collapse>
        </Fragment>
    );
};

MacroEditor.propTypes = {
    useMacro: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    onReset: PropTypes.func,
    onCheckBoxChange: PropTypes.func,
    onEditorChange: PropTypes.func
};
export default memo(MacroEditor);
